<script>
import Layout from '@layouts/main'

import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'

/**
 * Dashboard-1 Component
 */
export default {
  components: { Layout, Loading },
  data() {
    return {
      mostraForm: true,
      form: {},
      accountCategory: [
        {
          id: 1,
          descricao: 'Diretoria',
        },
        {
          id: 2,
          descricao: 'Marketing',
        },
        {
          id: 3,
          descricao: 'Recursos Humanos',
        },
        {
          id: 4,
          descricao: 'Comercial',
        },
      ],
      accountCategoryFields: [
        {
          key: 'id',
          label: 'ID',
          class: 'size-col-10',
        },
        {
          key: 'descricao',
          label: 'descricao',
          class: 'size-col-30',
        },
        { key: 'actions', label: '', class: 'size-col-10' },
      ],
      currentPage: 1,
      perPage: 20,
      showModal: false,
    }
  },
  computed: {},

  watch: {},
  mounted() {},
  methods: {
    loading(a) {
      a = !this.isLoading ? true : false
      return a
    },
    cadastra() {
      //   if (this.produtoEdit) {
      //     this.produtoEdit = {}
      //   }
      if (this.mostraForm === true) {
        this.mostraForm = false
      } else {
        this.mostraForm = true
        this.listar()
      }
    },
  },
}
</script>

<template>
  <Layout>
    <div class="bloco">
      <div class="cabecalho">
        <div class="row">
          <div class="col-md-11">
            <div class="titulo">Centros de custo</div>
            <div class="subTitulo">
              Gerencie as seus centros de custo.
            </div>
          </div>
          <div class="col-md-1 cadastra">
            <button class="btn btn-webreceita" @click="cadastra">
              <span v-if="mostraForm">Novo</span>
              <span v-else>Lista</span>
            </button>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="borda"></div>
        </div>
      </div>

      <div class="row" v-if="mostraForm">
        <div class="col-md-2">
          <b-form-group id="input-group-1" label="Descrição" label-for="filter">
            <v-select class="style-select" label="nome"></v-select>
          </b-form-group>
        </div>

        <div class="col-md-2">
          <button class="btn btn-webreceita" @click.prevent="listar"
            >Filtrar</button
          >
        </div>
      </div>

      <div v-if="mostraForm">
        <b-table
          striped
          hover
          responsive="sm"
          borderless
          bordered
          outlined
          small
          :items="accountCategory"
          :fields="accountCategoryFields"
          :per-page="perPage"
        >
          <template v-slot:cell(actions)="row">
            <div class="btn-group mb-2">
              <button
                v-b-tooltip.hover
                title="Editar"
                type="button"
                class="btn btn-light"
                @click="editRegister(row.item)"
              >
                <i class="uil uil-edit"></i>
              </button>
              <button
                v-b-tooltip.hover
                title="Deletar"
                type="button"
                class="btn btn-light"
                @click="modalDelete(row.item.id_produto)"
              >
                <i class="uil uil-trash-alt"></i>
              </button>
            </div>
          </template>
          <template v-slot:cell(ativo)="row">{{
            row.item.ativo ? 'Sim' : 'Não'
          }}</template>
        </b-table>
        <b-pagination
          v-model="currentPage"
          size="md"
          :total-rows="rows"
          :per-page="perPage"
        ></b-pagination>
      </div>

      <div v-else>
        <b-form>
          <div class="row">
            <div class="col-4">
              <div class="row">
                <div class="col">
                  <b-form-group label="Descrição">
                    <b-form-input />
                  </b-form-group>
                </div>
              </div>
            </div>
          </div>
          <b-button type="submit" variant="success" @click.prevent="salvar"
            >Salvar</b-button
          >
        </b-form>
      </div>
    </div>

    <b-modal id="modal-delete" title="Aviso" title-class="font-18">
      <p>Tem certeza que deseja excluir este registro?</p>
      <template v-slot:modal-footer>
        <b-button variant="light" @click="$bvModal.hide('modal-delete')"
          >Não</b-button
        >
        <b-button variant="danger" @click="Deletar">Sim</b-button>
      </template>
    </b-modal>
    <b-overlay :show="isLoading" no-wrap>
    </b-overlay>
  </Layout>
</template>
<style lang="scss">
.bloco {
  margin-top: 30px;
  background-color: #fff;
  padding: 40px;
  border-radius: 0.25rem;
  .titulo {
    font-size: 25px;
    color: #008e75;
    margin-bottom: 10px;
    font-weight: bold;
  }
  .subtitulo {
    margin-bottom: 10px;
  }
  .borda {
    margin-top: 15px;
    margin-bottom: 15px;
    border-bottom: solid 1px #edeff4;
  }
  .formulario {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .btn-webreceita {
    margin-top: 30px;
    margin-bottom: 10px;
    background-color: #008e75;
    padding: 5px 30px;
    &.botaoTopo {
      float: right;
    }
  }
  .filterButton {
    // margin-top: 5px;
    // margin-bottom: 10px;
    background-color: #008e74c7;
    padding: 0 20px;
  }
  .cadastra {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
}
</style>